import React from "react";
import { intl } from "LocaleWrapper";
import { Card, FormGroup } from "@cofano/cck";
import { Box } from "@mui/material";
import AssignmentInd from "@mui/icons-material/AssignmentInd";
import { ContractLink, DossierLink, RelationLink } from "utils/LinkUtils";
import { CharterFromCharterSideviewer } from "view/charters/components/sideviewer/useCharterSideviewer";
import { CharterType } from "__generated__/enums";
import CharterTypeTag from "view/charters/components/tags/CharterTypeTag";
import VoyageLocalSelect, { VoyageLocalSelectOption } from "view/voyages/components/selects/VoyageLocalSelect";
import CharterSubtypeTag from "view/charters/components/tags/CharterSubtypeTag";
import SalesCharterStatusChanger from "view/charters/components/status/SalesCharterStatusChanger";

const CharterSideviewerDetailsBlock = ({
	charter,
	voyages,
	selectedVoyageId,
	onVoyageChange,
}: {
	charter: CharterFromCharterSideviewer;
	voyages: VoyageLocalSelectOption[];
	selectedVoyageId?: number;
	onVoyageChange: (voyageId: number | undefined) => void;
}) => {
	return (
		<React.Fragment>
			<Card
				title={<DossierLink charter={charter} />}
				subtitle={<RelationLink relation={charter.type == CharterType.Sales ? charter.debtor : charter.creditor} />}
				icon={<AssignmentInd fontSize="small" color="primary" />}
				actions={voyages.length > 1 ? [ {
					render: () => (
						<Box sx={{ width: 180 }}>
							<VoyageLocalSelect
								voyages={voyages}
								value={voyages.find(voyage => voyage.id === selectedVoyageId)}
								onChange={(option) => onVoyageChange(option?.id)} />
						</Box>
					),
				} ] : undefined}
				collapsable
			>
				{"status" in charter && (
					<FormGroup
						labelPlacement="left-center"
						label={intl.formatMessage({ id: "STATUS" })}>
						<SalesCharterStatusChanger charter={charter} onCompleted={() => {}} />
					</FormGroup>
				)}

				<FormGroup
					labelPlacement="left-center"
					label={intl.formatMessage({ id: "TYPE" })}>
					<div style={{ display: "flex", gap: 8 }}>
						<CharterSubtypeTag type={charter.subtype} />
						<CharterTypeTag type={charter.type} />
					</div>
				</FormGroup>

				<FormGroup
					labelPlacement="left-center"
					label={intl.formatMessage({ id: "CREDITOR" })}>
					<RelationLink relation={charter.creditor} />
				</FormGroup>

				<FormGroup
					labelPlacement="left-center"
					label={intl.formatMessage({ id: "DEBTOR" })}>
					<RelationLink relation={charter.debtor} />
				</FormGroup>

				{"broker" in charter && (
					<FormGroup
						labelPlacement="left-center"
						label={intl.formatMessage({ id: "BROKER" })}>
						<RelationLink relation={charter.broker} />
					</FormGroup>
				)}

				{charter.customerReference && (
					<FormGroup
						labelPlacement="left-center"
						label={intl.formatMessage({ id: "CUSTOMER_REFERENCE" })}>
						{charter.customerReference}
					</FormGroup>
				)}

				{charter.contract && (
					<FormGroup
						labelPlacement="left-center"
						label={intl.formatMessage({ id: "CONTRACT" })}>
						<ContractLink contract={charter.contract} />
					</FormGroup>
				)}
			</Card>
		</React.Fragment>
	);
};

export default CharterSideviewerDetailsBlock;
